import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import find from 'lodash/find';

import { CMSConditions, CMSMetaData } from '../../../models/cms-data';


const cmsConfig = {
  routing: {
    7: {
      shortCode: '7pxEWn0ev9NiFX8LQFAHQk' ,
      flow: 'pH1CkdAGO9Rob2knSwxqS' ,
      step: '1h0AhlaNlv2mnuORtjF9nh'
    },
    8: {
      integrationId: '5RRYEV8h1MxCUKbY5cmJN6',
      apiKey: '6bVT6wzsiNQE8CLSJ6zbuM',
      flow: 'eeXirwxxddZtMBGOV6Aeg',
      step: '1ucGNywXFbaqMJRAMhlBJz'
    },
    6: {
      integrationId : '6SdxUyZFnsWXuAhgZBow8',
      apiKey: '3Yddx8YgASplk6Vj1e3MLj',
      flow: '1lVxpPNqUl47rJ8SPfjv6C',
      step: '4kzSLM3T4KFklcnfXzUmTE'
    }
  },
  keyword: {
    conflictingKeyword: '1noxXRUji6pfOepB4Hy7E4'
  },
  apiIntegration: {
      baseElement: '1SY6BLsPrrf1exfD1aa4hS',
      elementValidation: '27ORJ0uGZ5KlfnV3YH8Nyc',
      key: '1K5s3fTRBXsezcIewUNqXw',
      value: '5gCfEO6tAVRFrFugqCQke'
  },
  preview: {
    SelectRoute: '68wvPV3zD9LQbBiuLAiG7I',
    IMSI: '6wMPCD1pWHNk7zFpwc0Eo',
    MNOSessionID: '4ugABk7VUwtAWBZpTUTe1A'
  },
  nodeBuild: {
    displayType: '68U820YFw5FrleLLtMwe9x',
    varName: '3i2cHLBcmK9BbRx4UdNcUH',
    optionSeperator: 'ZaP9jgBllgqUcFrUf14Dy',
    multipleGroups: '69NSYZ1TtscuE83LIP5UlQ',
    multipleSelection: '7y1lbhcYH4FsblrdyW5fFR',
    next: '4cwCRw9WeRDfV1o6WNARU',
    addNew: '5CkCd2YgHDX97cJAksDubp',
    listOptionPattern: '7r2wwxcGFw6UKgDlHvNLSp',
    listValuePattern: '50WzDBuKZA0wvpzbEazWQG',
    listDescriptionPattern: '4cEw2art3L4254e4B3xliJ',
    filterBy: '1fd717NaQbbBarpKN97mcX',
    exclude: '3Bv5cFD1e6NAyuMYzGSATa',
    varNameDynamicList: '4Sdyg0zrnKg2RuoCWMHS1a',
    optSeperatorDynamicList: '2Fzh6QyRvFBoFVfQhsQIFh',
    isPrivateVariable: '4bmq2tJdOuXMq6w4G8XkSN',
    showPageResults: '26Sm014HeHfNzCtAcGTCjW',
    AMBmultipleSelections: '42Hrw2jz8F7tz8bXHiPVln',
    generateOrderNo: '1i2RihXWAIBzia6ntdMV3b',
    requiredKeyboard: '16kuTTIqQKk9RsR5s4WYuW',
    fallbackMessage: '47eKNRy13ojskRwLUxKY3C',
    validationMessage: '6sOiV1PPPMvuKtYzmFakim',
    selectContactFieldsMessage: '3jlK3mnbuKKTi0vQuLgeKy',
    enablePagination: '2llTwt1I5i1Z9BLRhZ1T8c',
    groupSeparator: '3z6Z8Y9uuAdzD7Rpw19ihm',
    sendTemplate: '38Rr5pa3e4kgmuSj6JSvzD',
  },
  nodeBuilder: {
    8: {
      BUTTON: '33OpEKXTAlXvk3Hyjj5JrP',
      LIST: '4CmfP4wQi3kmhX2SZW03pB',
      NUMBER: '1eIDfjgyNKPZoYdks8nmlQ',
      AUTO: '2EjwLaMlMpfTBi8Fhtnxoq',
    },
    6: {
      NUMBER: '7FQUG2CtBNwzLBYR1wzD9K'
    },
    7: {
      NUMBER: '6nfZmUJRKribMfWuQFqBAs'
    },
    13: {
      BUTTON: '3zKBXosvWTxiC9qw7XgUjL',
      LIST: '6XWbsiK67hULePYd6XRMCg',
      AUTO: '1KrWO8Kz3qH81SVX9dBGU7'
    }
  },
    analytics: {
        settings: 'y1T82WizzjMIX8QpxyEZC',
        single: '5a5IJapkmT2u7fwhbljdt0',
        startEnd: '6Q4FAwCCQ0wP2bOLG839F0',
        multi: '1RbLKUxGZh54wX622GthXL'
    },
    settings: {
        sessionTimeOut: '3NEIs7w538MEkYwv02LUnU'
    }
};

@Injectable({
    providedIn: 'root'
})
export class CMSService {
    private readonly baseUri: string = environment.controlBaseUrl;
    private readonly uri: string = '/api/cms';
    private cmsMetaData: CMSMetaData;

    constructor(private http: HttpClient) {}

    public cmsCall(entryId: string, cmsType: string, lang?: string) {
        if (entryId && cmsType) {
            const url = `${this.baseUri}${this.uri}/${cmsType}/${entryId}/${lang ? lang : ''}`;
            return this.http.get(url);
        }
    }

    getCMSMetaData(): CMSMetaData {
        return this.cmsMetaData;
    }

    setCMSMetaData(cmsFields: CMSConditions) {
        let contentId = '';

        if (cmsFields.type === 'routing' || cmsFields.type === 'nodeBuilder') {
            contentId = find(cmsConfig[cmsFields.type][cmsFields.channelId], (val, key) => {
                return (key === cmsFields.field) ? val : '';
            });
        } else if (cmsFields.type === 'keyword'
                || cmsFields.type === 'apiIntegration'
                || cmsFields.type === 'preview'
                || cmsFields.type === 'nodeBuild'
                || cmsFields.type === 'analytics'
                || cmsFields.type === 'settings'
                ) {
            contentId = cmsConfig[cmsFields.type][cmsFields.field];
        }

        this.cmsMetaData = {
            size: cmsFields.size,
            contentId
        };
    }

    cmsMetaDataBuilder(cmsFields: CMSConditions): CMSMetaData {
      const contentId = find(cmsConfig[cmsFields.type][cmsFields.channelId], (val, key) => {
          return (key === cmsFields.field) ? val : '';
      });

      return {
            size: cmsFields.size,
            contentId
      };
    }
}
